import React, { useState } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Label from 'components/general/Label';
import Noc from "components/presentation/Noc";
import Discipline from "components/presentation/Discipline";
import Moment from "react-moment";
import { getDateTimeFormat } from 'helpers/utils'
import { getAge, getHeight, getWeight, isParalympic, CompetitionFromStore, usePathPhoto, SoundPlayer, getFullPath, DIR_MEDIA_TYPE, } from "helpers/utils";
export default function PersonInfo({ data }) {
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const athleteCode = paramsURL['mirs_code'];
    const [showImage, setShowImage] = useState(true);
    const competition = CompetitionFromStore();
    const codePhoto = usePathPhoto();

    const DisplayedNoc = React.memo(() => {
        const nocObject = paramsURL?.mirs_path === "coach" ? data?.person?.nationality : data?.person?.organisation;
        return <Noc showLongDesc={true} {...nocObject} showImgAlt={false} />
    }, [data?.person?.organisation, data?.person?.nationality, paramsURL?.mirs_path]);

    const hideImg = () => {
        setShowImage(false);
    };

    const url = (showImage && data?.person?.image) ? getFullPath(athleteCode, DIR_MEDIA_TYPE.MEDIUM, data?.person?.image.imageExtension) : codePhoto;

    return (
        <>
            {data && data?.person && data?.person?.code &&
                <div className="container-fluid mb-2">
                    <div className="row">
                        <div className="col-3 px-1">
                            <picture>
                                <img className="wrsBiosDetail__image" alt="" src={url} onError={() => hideImg()} />
                            </picture>
                            <div id='OCS_Athlete_Details_Injection' className='div-below-athlete-picture'></div>
                        </div>
                        <div className="col-9 px-1">
                            <div className='row'>
                                {data?.person?.familyName && <div className="pt-2"><b>{data?.person?.familyName?.toUpperCase()} {data?.person?.givenName || ''}{data?.person?.audioFile?.audioType && <>&nbsp;<SoundPlayer audioPath={getFullPath(athleteCode, DIR_MEDIA_TYPE.AUDIO, data?.person?.audioFile?.audioType)} /></>} </b></div>}
                                <div className="wrsNoc" >
                                    <DisplayedNoc />
                                </div>
                                {data?.person?.disciplines &&
                                    data?.person?.disciplines.map((item, key) => <div className="pt-2" key={item.code}><Discipline code={item.code} description={item.description} /></div>)
                                }
                            </div>
                            <div className='row'>
                                <div className="col-md-6">
                                    {data?.person?.birthDate && <div className="pt-2"><b><Label data="HeaderBirthDate" />:&nbsp;</b> <Moment parse="YYYY-MM-DD" format={getDateTimeFormat('DayMonthShortYear')}>{data?.person?.birthDate}</Moment></div>}
                                    {data?.person?.medicalClass && <div className="pt-2"><b><Label data="HeaderMedical" />:&nbsp;</b> {data?.person?.medicalClass?.classCode || 'N/A'}</div>}
                                    {/* <div className="pt-2"><b><Label data="HeaderMedical" />:&nbsp;</b> {data?.person?.medicalClass?.classCode || 'N/A'}</div> */}
                                    {/* {!isInvictus(competition) && <div className="pt-2"><b><Label data="HeaderAge" />:&nbsp;</b> {getAge(data?.person?.birthDate)}</div>} */}
                                    {data?.person?.birthDate && <div className="pt-2"><b><Label data="HeaderAge" />:&nbsp;</b> {getAge(data?.person?.birthDate)}</div>}
                                    {data?.person?.personGender?.description && <div className="pt-2"><b><Label data="HeaderGender" />:&nbsp;</b> {data?.person?.personGender?.description}</div>}
                                    {data?.person?.mainFunction?.description && <div className="pt-2"><b><Label data="LabelFunction" />:&nbsp;</b> {data?.person?.mainFunction?.description}</div>}
                                    {data?.person?.olympicSolidarity && <div className="pt-2"><b><Label data="LabelOlympicSolidarity" />:&nbsp;</b> {data?.person?.olympicSolidarity ? <Label data="LabelYes" /> : <Label data="LabelNo" />}</div>}
                                    {!isParalympic(competition) && data.person.height > 0 &&
                                        <div className="pt-2"><b><Label data="HeaderHeightMFt" />:&nbsp;</b> {getHeight(data?.person?.height)}</div>
                                    }
                                    {!isParalympic(competition) && data.person.weight > 0 &&
                                        <div className="pt-2"><b><Label data="HeaderWeightKgLb" />:&nbsp;</b> {getWeight(data?.person?.weight)}</div>
                                    }
                                </div>
                                <div className="col-md-6">
                                    {data?.person?.participantBio?.placeofBirth && <div className="pt-2"><b><Label data="LabelBirthPlace" />:&nbsp;</b> {data?.person?.participantBio?.placeofBirth}</div>}
                                    {data?.person?.participantBio?.countryofBirth?.description && <div className="pt-2"><b><Label data="HeaderBirthCountry" />:&nbsp;</b> {data?.person?.participantBio?.countryofBirth?.description}</div>}
                                    {data?.person?.participantBio?.placeofResidence && <div className="pt-2"><b><Label data="labelbioPLACE_OF_RESIDENCE" />:&nbsp;</b> {data?.person?.participantBio?.placeofResidence}</div>}
                                    {data?.person?.participantBio?.countryofResidence?.description && <div className="pt-2"><b><Label data="LabelResidenceCountry" />:&nbsp;</b> {data?.person?.participantBio?.countryofResidence?.description}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            }
        </>
    )
}